import { useQuery } from 'react-query';
import { httpRequest } from '../config/api';

const GET_AUDIT_LOGS = 'GET_AUDIT_LOGS';
const GET_AUDIT_LOG_DETAIL = 'GET_AUDIT_LOG_DETAIL';

/**
 * Build URLSearchParams for the GET /api/audit-logs endpoint.
 * Arrays (actions, resource_types, statuses) are sent as repeated query params.
 */
function buildParams(filters = {}) {
  const p = new URLSearchParams();
  if (filters.from_date) p.append('from_date', filters.from_date);
  if (filters.to_date) p.append('to_date', filters.to_date);
  if (filters.search) p.append('search', filters.search);
  if (filters.my_actions_only) p.append('my_actions_only', 'true');
  if (filters.user_id) p.append('user_id', filters.user_id);
  if (filters.page) p.append('page', String(filters.page));
  if (filters.size) p.append('size', String(filters.size));
  if (filters.sort_order) p.append('sort_order', filters.sort_order);
  if (filters.project_id) p.append('project_id', filters.project_id);
  if (filters.period_id) p.append('period_id', filters.period_id);
  (filters.actions || []).forEach(a => p.append('actions', a));
  (filters.resource_types || []).forEach(t => p.append('resource_types', t));
  (filters.statuses || []).forEach(s => p.append('statuses', s));
  return p;
}

export const auditLogService = {
  listLogs: filters => httpRequest.get(`api/audit-logs?${buildParams(filters)}`),
  getLog: id => httpRequest.get(`api/audit-logs/${id}`)
};

/**
 * Paginated, filterable list of audit log entries.
 * Matches the shape expected by ActivityLogPage: { items, total, pages }.
 */
export const useAuditLogs = (filters = {}) =>
  useQuery([GET_AUDIT_LOGS, filters], () => auditLogService.listLogs(filters), {
    keepPreviousData: true
  });

/**
 * Full detail for a single audit log entry (includes metadata JSONB).
 * Only fetches when `id` is truthy.
 */
export const useAuditLogDetail = id =>
  useQuery([GET_AUDIT_LOG_DETAIL, id], () => auditLogService.getLog(id), {
    enabled: !!id
  });
